export class Usuario {
    id: number;
    idTercero: number;
    nombreDeUsuario: string;
    estaActivo: boolean;
    idRol: number;
}
